import React from "react";
import { Breadcrumb, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Privacy = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main pt-4 pb-5">
        <Container>
          <div className="product_breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Privacy Policy</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div className="privacy_main_content">
            <h1 className="blue_bg mb-0">Privacy Policy</h1>
            <div className="white_bg p-4 policy_content">
              <h3 className="mb-2">Purpose</h3>
              <p>
                The purpose of this privacy policy (this "Privacy Policy") is to
                inform users of our Site of the following:
              </p>
              <p>
                The personal data we will collect;
                <br />
                Use of collected data;
                <br />
                Who has access to the data collected;
                <br />
                The rights of Site users; and
                <br />
                The Site's cookie policy.
              </p>
              <p>
                This Privacy Policy applies in addition to the terms and
                conditions of our Site.
              </p>
              <h3 className="mb-2">Consent</h3>
              <p>
                By using our Site users agree that they consent to: <br />{" "}
                <br />
                The conditions set out in this Privacy Policy; and <br />
                The collection, use, and retention of the data listed in this
                Privacy Policy.
              </p>
              <h3>Personal Data We Collect</h3>
              <p>
                We only collect data that helps us achieve the purpose set out
                in this Privacy Policy. We will not collect any additional data
                beyond the data listed below without notifying you first.
              </p>
              <h3>Data Collected Automatically</h3>
              <p>
                When you visit and use our Site, we may automatically collect
                and store the following information: <br />
                IP address;
                <br /> Location; <br />
                Hardware and software details; <br />
                Clicked links;
                <br /> and Content viewed.
              </p>
              <h3>Data Collected in a Non-Automatic Way</h3>
              <p>
                We may also collect the following data when you perform certain
                functions on our Site: <br />
                First and last name;
                <br />
                Age;
                <br />
                Date of birth;
                <br />
                Email address; <br />
                Phone number;
                <br /> and Address.
                <br />
                <br /> This data may be collected using the following methods:
                <br />
                <br /> Creating an account;
                <br /> and Birthday Club signup.
              </p>
              <h3>Data Collected in a Non-Automatic Way</h3>
              <p>
                Data collected on our Site will only be used for the purposes
                specified in this Privacy Policy or indicated on the relevant
                pages of our Site. We will not use your data beyond what we
                disclose in this Privacy Policy.
                <br />
                <br />
                Advertising;
                <br />
                Website Optimization; and
                <br />
                Statistics.
                <br />
              </p>
              <p>
                The data we collect when the user performs certain functions may
                be used for the following purposes: <br />
                <br />
                Communication; and
                <br />
                Advertising.
              </p>
              <h3>Who We Share Personal Data With:</h3>
              <p>Employees</p>
              <p>
                We may disclose user data to any member of our organization who
                reasonably needs access to user data to achieve the purposes set
                out in this Privacy Policy.
              </p>
              <h3>Other Disclosures</h3>
              <p>
                We will not sell or share your data with other third parties,
                except in the following cases:
                <br />
                <br />
                If the law requires it;
                <br />
                If it is required for any legal proceeding;
                <br />
                To prove or protect our legal rights; and
                <br />
                To buyers or potential buyers of this company in the event that
                we seek to sell the company.
              </p>
              <p>
                If you follow hyperlinks from our Site to another Site, please
                note that we are not responsible for and have no control over
                their privacy policies and practices.
              </p>
              <h3>How Long We Store Personal Data</h3>
              <p>
                User data will be stored until the purpose the data was
                collected for has been achieved.
                <br />
                You will be notified if your data is kept for longer than this
                period.
              </p>
              <h3>How We Protect Your Personal Data</h3>
              <p>
                In order to protect your security, we use the strongest
                available browser encryption and store all of our data on
                servers in secure facilities. All data is only accessible to our
                employees. Our employees are bound by strict confidentiality
                agreements and a breach of this agreement would result in the
                employee's termination.
              </p>
              <p>
                While we take all reasonable precautions to ensure that user
                data is secure and that users are protected, there always
                remains the risk of harm. The Internet as a whole can be
                insecure at times and therefore we are unable to guarantee the
                security of user data beyond what is reasonably practical.
              </p>

              <h3>Children</h3>
              <p>
                We do not knowingly collect or use personal data from children
                under 13 years of age. If we learn that we have collected
                personal data from a child under 13 years of age, the personal
                data will be deleted as soon as possible. If a child under 13
                years of age has provided us with personal data their parent or
                guardian may contact our privacy officer.
                <br />
                <br />
                How to Access, Modify, Delete, or Challenge the Data Collected
                <br />
                <br />
                If you would like to know if we have collected your personal
                data, how we have used your personal data, if we have disclosed
                your personal data and to who we disclosed your personal data,
                or if you would like your data to be deleted or modified in any
                way, please contact our privacy officer here:
                <br />
                <br />
                LibertyPrograms.com Privacy Officer
                <br />
                admin@libertyprograms.com
                <br />
                (833) 465 0300
                <br />
                {/* 1546 BW 56 ST, New York, NY, 10009 */}
                2248 Broadway #1721 <br /> New York, NY 10024 <br /> United
                States
              </p>
              <h3>Do Not Track Notice</h3>
              <p>
                Do Not Track ("DNT") is a privacy preference that you can set in
                certain web browsers. We respond to browser-initiated DNT
                signals. If we receive a DNT signal that indicates a user does
                not wish to be tracked, we will not track that user.
                <br />
                <br />
                How to Opt-Out of Data Collection, Use or Disclosure <br />
                <br />
                In addition to the method(s) described in the How to Access,
                Modify, Delete, or Challenge the Data Collected section, we
                provide the following specific opt-out methods for the forms of
                collection, use, or disclosure of your personal data specified
                below:
                <br />
                <br />
                You can opt-out of the use of your personal data for marketing
                emails. You can opt-out by clicking "unsubscribe" on the bottom
                of any marketing email or updating your email preferences under
                "Your Account"
              </p>
              <h3>Cookie Policy</h3>
              <p>
                A cookie is a small file, stored on a user's hard drive by a
                website. Its purpose is to collect data relating to the user's
                browsing habits. You can choose to be notified each time a
                cookie is transmitted. You can also choose to disable cookies
                entirely in your internet browser, but this may decrease the
                quality of your user experience.
                <br />
                <br />
                We use the following types of cookies on our Site:
                <br />
                <br />
                Functional cookies
                <br />
                <br />
                Functional cookies are used to remember the selections you make
                on our Site so that your selections are saved for your next
                visits;
                <br />
                <br />
                Analytical cookies
                <br />
                <br />
                Analytical cookies allow us to improve the design and
                functionality of our Site by collecting data on how you access
                our Site, for example data on the content you access, how long
                you stay on our Site, etc;
                <br />
                <br />
                Targeting cookies
                <br />
                <br />
                Targeting cookies collect data on how you use the Site and your
                preferences. This allows us to personalize the information you
                see on our Site for you; and Third-Party Cookies
                <br />
                <br />
                Third-party cookies are created by a website other than ours. We
                may use third-party cookies to achieve the following purposes:
                <br />
                <br />
                Monitor user preferences to tailor advertisements around their
                interests.
              </p>
              <h3>Modifications</h3>
              <p>
                This Privacy Policy may be amended from time to time in order to
                maintain compliance with the law and to reflect any changes to
                our data collection process. When we amend this Privacy Policy
                we will update the "Effective Date" at the top of this Privacy
                Policy. We recommend that our users periodically review our
                Privacy Policy to ensure that they are notified of any updates.
                If necessary, we may notify users by email of changes to this
                Privacy Policy.
              </p>

              <h3>Contact Information</h3>
              <p>
                If you have any questions, concerns or complaints, you can
                contact our privacy officer, Liberty Programs Privacy Officer,
                at:
                <br />
                <br />
                admin@libertyprograms.com
                <br />
                (833) 465 0300
                <br />
                {/* 1546 BW 56 ST, New York, NY, 10009 */}
                2248 Broadway #1721 <br /> New York, NY 10024 <br /> United
                States
              </p>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Privacy;
